import { useState } from 'react'

/** 128 random bits as hex; `crypto.randomUUID` only exists on https, and plain-http hosts exist. */
const newKey = () =>
	Array.from(crypto.getRandomValues(new Uint8Array(16)), (b) =>
		b.toString(16).padStart(2, '0'),
	).join('')

/**
 * The `Idempotency-Key` of one AI draft. A draft takes tens of seconds, so a phone that drops off
 * the network mid-draft looks failed while the api finishes and saves the result; "Try again" must
 * send the same key, so the api hands back what it already made instead of drafting a second one.
 * It is kept across failures and replaced once a draft succeeds, so the next draft is its own.
 */
export function createDraftKey() {
	let key: string | null = null
	return {
		/** The headers for the request; the same key until `done`. */
		headers: () => ({ 'idempotency-key': (key ??= newKey()) }),
		/** The draft succeeded: the next one is a new action. */
		done: () => {
			key = null
		},
	}
}

/** One key holder for the life of the component that drafts. */
export const useDraftKey = () => useState(createDraftKey)[0]
